import React, { useState, useEffect } from "react";
import { Button, Icon } from "react-onsenui";

const SplashScreen = ({
  isInstalling,
  installError,
  retryInstall,
  checkInstallation,
  appInstalled,
}) => {
  const [installStatus, setInstallStatus] = useState(isInstalling);
  const [isIos, setIsIos] = useState(false);
  const [isAndroid, setIsAndroid] = useState(false);

  useEffect(() => {
    // Detect if the user is on iOS or Android
    const userAgent = window.navigator.userAgent.toLowerCase();
    setIsIos(/iphone|ipad|ipod/.test(userAgent));
    setIsAndroid(/android/.test(userAgent));

    // Periodically check installation status every 2-3 seconds
    const interval = setInterval(() => {
      checkInstallation().then((status) => {
        console.log("checkInstallation", status);
        if (status === true) {
          window.location.assign("/");
        }
        setInstallStatus(status);
      });
    }, 3000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [checkInstallation]);

  const handleRedirectOrClose = () => {
    if (window.opener) {
      // Close the window if it was opened by a script
      window.close();
    } else {
      // Redirect to the IoFE store
      window.location.assign("https://www.iofe.in/");
    }
  };

  return (
    <div
      style={{
        height: "90vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        backgroundColor: "white",
        position: "relative",
      }}
    >
      <img
        src="/odisha-logo.png"
        height={100}
        alt="logo"
        style={{
          objectFit: "contain",
          filter:
            "invert(39%) sepia(41%) saturate(592%) hue-rotate(56deg) brightness(89%) contrast(93%)",
        }}
      />
      {appInstalled && isIos ? (
        <div style={{ textAlign: "center" }}>
          <p><b>To install the app:</b></p>
          <ol style={{ textAlign: "left" }}>
            <li>Tap the <b>Share 
            <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="m8 10.1073c.34225 0 .61245-.27858.61245-.60557v-6.01298l-.04804-.89619.34825.45415.78658.84775c.10807.12111.25818.18166.40826.18166.2942 0 .5404-.21799.5404-.52681 0-.15744-.06-.27855-.1681-.38755l-2.00545-1.94377c-.16212-.15744-.31223-.21799-.47435-.21799s-.31823.06055-.47434.21799l-2.00546 1.94377c-.11409.109-.17413.23011-.17413.38755 0 .30882.24618.52681.54039.52681.15011 0 .30623-.06055.4083-.18166l.79258-.84775.34825-.45415-.05404.89619v6.01298c0 .32699.2762.60557.61845.60557zm-3.46452 4.8927h6.92902c1.333 0 2.0355-.7085 2.0355-2.0346v-5.89793c0-1.32612-.7025-2.0346-2.0355-2.0346h-1.59114v1.35035h1.47704c.5224 0 .8106.27249.8106.82353v5.61935c0 .5571-.2882.8236-.8106.8236h-6.70084c-.52838 0-.81059-.2665-.81059-.8236v-5.61935c0-.55104.28221-.82353.81059-.82353h1.49509v-1.35035h-1.60917c-1.32696 0-2.03548.70848-2.03548 2.0346v5.89793c0 1.3322.70852 2.0346 2.03548 2.0346z" fill="#001018"/></svg></b> button.</li>
            <li>Find and tap <b>Add to Homescreen</b>.</li>
          </ol>
          <Button
            onClick={handleRedirectOrClose}
            style={{
              background: "#5C7232",
            }}
          >
            Close Window
          </Button>
        </div>
      ) : appInstalled && isAndroid ? (
        <>
          <p>
            <b style={{ color: "#5C7232" }}>
              App Installed &nbsp;
              <Icon icon="fa-check" /> {/* Using FontAwesome's 'check' icon */}
            </b>
          </p>
          <p>
            {/* Check your Home Screen or App Drawer for the RatiFi Redux App. */}


          <ol style={{ textAlign: "left" }}>
            <li>Check your Home Screen  <b style={{color:"#5C7232"}}>RatiFi Redux</b> Shortcut </li>
            <div style={{textAlign:'left'}}>or</div>
            <li>Check the App Drawer for <b style={{color:"#5C7232"}}>RatiFi Redux</b>.</li>
          </ol>
          </p>
          <Button
            onClick={handleRedirectOrClose}
            style={{
              background: "#5C7232",
            }}
          >
            Close Window
          </Button>
        </>
      ) : installStatus ? (
        <p>Installing the app... Please wait.</p>
      ) : installError ? (
        <>
          <p>Installation failed. Please retry.</p>
          <b onClick={retryInstall}>Retry Installation</b>
        </>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};

export default SplashScreen;
